<div class="col-sm-10 offset-sm-1">
  <form #besteffortsform="ngForm" class="col-md-12 padding-lr-0px row" name="besteffortsform"
        [class.was-validated]="formSubmitted">
    <div id="beEditDC" block-ui="BEDeliveryCommitmentEdit">

      <!-- DC Information Section -->

      <div class="border-bottom-dashed">
        <div class="padding-top-30px padding-bottom-30px fhlb-blue-font">
          <strong>{{cmsModel.DCInformationText}}</strong>
        </div>
        <div class="row padding-bottom-20px">
          <div class="col-sm-7">
            <div class="row padding-bottom-10px">
              <div class="col-sm-6 text-align-right-sm">
                <label class="control-label">{{cmsModel.AuthorizedByBE}}</label>
              </div>
              <div class="col-sm-6 padding-left-0px feedback-display-font padding-top-7 text-word-wrap">
                {{dcMainModel.dcDetails.authorizedByName}}
              </div>
            </div>
            <div class="row padding-bottom-10px">
              <div class="col-sm-6 text-align-right-sm">
                <label class="control-label">{{cmsModel.EmailAddressText}}</label>
              </div>
              <div class="col-sm-6 padding-left-0px feedback-display-font padding-top-7 text-word-wrap">
                {{dcMainModel.dcRequestModel.bankUser.emailAddress}}
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 text-align-right-sm">
                <label class="control-label">{{cmsModel.MasterCommitmentNumber}}:</label>
              </div>
              <div class="col-sm-4 form-group mb-3 margin-left--15px">
                <input type="text" id="mcNumberBE" name="mcNumberBE" class="form-control"
                       [(ngModel)]="dcExistingModel.deliveryCommitment.masterCommitmentId"
                       #mcNumberBE="ngModel" allowNumbersOnly show-errors disabled />
                <div class="help-block row"
                     *ngIf=" (mcNumberBE.invalid && formSubmitted) || (mcNumberBE.errors?.required && (mcNumberBE.dirty || mcNumberBE.touched))">
                  <p class="col-sm-12">
                    This field is required
                  </p>
                </div>
              </div>
            </div>
            <div class="row padding-bottom-10px">
              <div class="col-sm-6 text-align-right-sm">
                <label class="control-label">{{cmsModel.DeliveryTypeText}}:</label>
              </div>
              <div class="col-sm-6 padding-left-0px feedback-display-font padding-top-7px">
                {{dcExistingModel.deliveryCommitment.deliveryType}}
              </div>
            </div>
            <div class="row padding-bottom-10px">
              <div class="col-sm-6 text-align-right-sm">
                <label class="control-label">{{cmsModel.DeliveryAmountText}}:</label>
              </div>
              <div class="col-sm-6 form-group mb-3 margin-left--15px">
                <input type="text" id="deliveryAmountBE" name="deliveryAmountBE" placeholder="$"
                       class="form-control" [(ngModel)]="dcExistingModel.deliveryCommitment.dcAmount"
                       allow-decimal-numbers real-time-currency #deliveryAmountBE="ngModel" (blur)="populateLTVAndTLTV()" show-errors required [disabled]="!isActiveAndUnfunded"/>
                <div class="help-block row"
                     *ngIf="(deliveryAmountBE.invalid && formSubmitted)||(deliveryAmountBE.errors?.required && (deliveryAmountBE.dirty || deliveryAmountBE.touched))">
                  <p class="col-sm-12">
                    This field is required
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-5">
            <div class="row">
              <div class="col-sm-6 text-align-right-sm">
                <label class="control-label">{{cmsModel.Product}}:</label>
              </div>
              <div class="col-sm-6 form-group mb-3 margin-left--12px">
                <label class="select height-auto">
                  <select id="productNameBE" name="productNameBE" class="form-select"
                          [(ngModel)]="productSelected" #productNameBE="ngModel" show-errors
                          (change)="onProductChange($event)" required [disabled]="!isActiveAndUnfunded">
                    <ng-container *ngFor="let item of productsList">
                      <option class="feedback-form-input" [ngValue]="item.productName">
                        {{item.productName}}
                      </option>
                    </ng-container>
                  </select>
                </label>
                <div class="help-block row"
                     *ngIf="(productNameBE.invalid && formSubmitted) || (productNameBE.errors?.required && (productNameBE.dirty || productNameBE.touched))">
                  <p class="col-sm-12">
                    This field is required
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 text-align-right-sm">
                <label class="control-label">{{cmsModel.SubProductText}}</label>
              </div>
              <div id="subProductBEDiv" class="col-sm-6 form-group mb-3 margin-left--12px">
                <label class="select height-auto">
                  <select id="subProductIdBE" name="subProductIdBE" class="form-select font-size"
                          [(ngModel)]="dcExistingModel.deliveryCommitment.subProductCode"
                          #subProductIdBE="ngModel" show-errors (change)="onSubProductChange($event)" required [disabled]="!isActiveAndUnfunded">
                    <ng-container *ngFor="let item of filteredSubProducts | orderBy: 'productCode';">
                      <option [ngValue]="item.subProductCode">
                        {{ item.subProductName }}
                      </option>
                    </ng-container>
                  </select>
                </label>
                <div class="help-block row"
                     *ngIf=" (subProductIdBE.invalid && formSubmitted) || (subProductIdBE.errors?.required && (subProductIdBE.dirty || subProductIdBE.touched))">
                  <p class="col-sm-12">
                    This field is required
                  </p>
                </div>
              </div>
              <!-- <div class="col-sm-12  font-size-2 font-color-dark-gray padding-bottom-10px">
                  <div class="padding-right-15px">
                      <div>
                          <div>
                              <div style="font-weight:bold;background-color:#E5F4FB"
                                  [innerHtml]="dcExistingModel.subProductDetails.dcMessageContent">
                                  <br />
                              </div>
                          </div>
                      </div>
                  </div>
              </div> -->
            </div>
            <div class="row">
              <div class="col-sm-6 control-label text-align-right-sm">
                <label>{{cmsModel.CommitmentTermExpDateText}}</label>
              </div>
              <div class="col-sm-6 form-group mb-3 text-align-left margin-left--12px padding-top-22px">
                <label class="select height-auto" data-ng-class="{'cursor-not-allowed'}">
                  <select id="commitmentTerm" name="commitmentTerm" class="form-select font-size"
                          [(ngModel)]="dcExistingModel.deliveryCommitment.originalDeliveryDate"
                          #commitmentTerm="ngModel" required show-errors disabled>
                    <!-- <ng-container *ngFor="let item of dcExistingModel.scheduleDetail.commitmentTerm"> -->
                    <option class="feedback-form-input" [ngValue]="commitmentTerm.value">
                      <!-- {{item.commitmentTerm}} - {{item.expirationDate | date:'MM/dd/yyyy'}} -->
                      {{dcExistingModel.deliveryCommitment.commitmentTerm}} - Days
                      {{
dcExistingModel.deliveryCommitment.originalDeliveryDate |
                                            date:'MM/dd/yyyy'
                      }}
                    </option>
                    <!-- </ng-container> -->
                  </select>
                </label>
                <div class="help-block row"
                     *ngIf=" (commitmentTerm.invalid && formSubmitted) || (commitmentTerm.errors?.required && (commitmentTerm.dirty || commitmentTerm.touched))">
                  <p class="col-sm-12">
                    This field is required
                  </p>
                </div>
              </div>
            </div>
            <div class="row padding-bottom-10px">
              <div class="col-sm-6 control-label padding-top-0px text-align-right-sm">
                <label>{{cmsModel.ExpirationDateText}}</label>
              </div>
              <div class="col-sm-4 padding-left-0px text-align-left margin-left-15px font-weight-100 margin-left-0px">
                <div class="feedback-display-font">
                  {{dcExistingModel.deliveryCommitment.originalDeliveryDate | date:'MM/dd/yyyy'}}
                </div>
              </div>
            </div>


            <div class="row padding-bottom-10px">
              <div class="col-sm-6 control-label text-align-right-sm padding-top-0px">
                <label>{{cmsModel.ScheduleText}}</label>
              </div>
              <div class="col-sm-4 padding-left-0px text-align-left margin-left-15px margin-left-0px">
                <div class="feedback-display-font font-weight-100">
                  {{dcExistingModel.deliveryCommitment.scheduleCode}}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 control-label text-align-right-sm">
                <label>{{cmsModel.NoteRate}}: </label>
              </div>
              <div class="col-sm-4 form-group mb-3 margin-left--12px">
                <input type="text" id="noteRate" name="noteRate" class="form-control" #noteRateControl
                       [(ngModel)]="dcExistingModel.deliveryCommitment.noteRate" required real-time-percent
                       allowPositiveNegative="false" [disabled]="!isActiveAndUnfunded" allowDecimalNumbers
                       #noteRate="ngModel" show-errors (blur)="onNoteRateManualChange()" />
                <div class="help-block row"
                     *ngIf=" (noteRate.invalid && formSubmitted) || (noteRate.errors?.required && (noteRate.dirty || noteRate.touched))">
                  <p class="col-sm-12">
                    This field is required
                  </p>
                </div>
              </div>
              <div class="col-sm-2 text-align-left padding-left-12px margin-top-6px margin-left--18px"
                   id="NoteRates">
                <a class="fa fa-percent fa-lg font-color-dark-orange form-control-static"
                   id="noteRateClick" [ngbPopover]="isActiveAndUnfunded ? popContent : null" placement="right"
                   (mouseenter)="openPopover(p)" autoClose="outside; inside" triggers="isActiveAndUnfunded ? 'manual' : ''"
                   #p="ngbPopover" container="body" (click)="isActiveAndUnfunded && p.open()" popoverclass="noteRatePopover"
                   tabindex="4"></a>

              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- Borrower Section -->

      <div class="border-bottom-dashed">
        <div class="row">
          <div class="col-sm-3">
            <div class="padding-top-20px padding-bottom-30px fhlb-blue-font">
              <strong>{{cmsModel?.BorrowerInformationText}}</strong>
            </div>
          </div>
          <div *ngIf="isFhlbcUser == false" class="col-sm-9">
            <div class="padding-top-20px padding-bottom-30px text-align-right">
              <p id="grayed-message">
                To request edits to the grayed out fields in this section, please
                call
                the MPF Service Center at 877-345-2673.
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-7">
            <div class="row">
              <div class="col-sm-6 text-align-right-sm">
                <label class="control-label">{{cmsModel?.BorrowerFirstName}}</label>
              </div>
              <div class="col-sm-6 form-group mb-3 margin-left--15px">
                <input type="text" id="borrowerFirstName" name="borrowerFirstName" alphanumeric
                       class="form-control"
                       [(ngModel)]="bestEffortsDeliveryData?.bestEffortsDeliveryData[0].borrowerFirstName"
                       maxlength="{{  25 }}" #borrowerFirstName="ngModel"
                       pattern="((?!\d{3}-?\d{2}-?\d{4}).)*$" required show-errors [disabled]="isFhlbcUser == false" />
                <div class="help-block row" *ngIf="(borrowerFirstName.errors?.required && (borrowerFirstName.touched || formSubmitted)) ||
                                            borrowerFirstName.errors?.pattern">
                  <p class="col-sm-12" *ngIf="borrowerFirstName.errors?.required">
                    This field is required
                  </p>
                  <p class="col-sm-12" *ngIf="borrowerFirstName.errors?.pattern">
                    This
                    field cannot contain SSN number
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 text-align-right-sm">
                <label class="control-label">{{cmsModel?.BorrowerMiddleInitial}}</label>
              </div>
              <div class="col-sm-2 form-group mb-3 margin-left--15px">
                <input type="text" id="borrowerMiddleInitial" name="borrowerMiddleInitial"
                       class="form-control"
                       [(ngModel)]="bestEffortsDeliveryData?.bestEffortsDeliveryData[0].borrowerMiddleInitial"
                       alphanumeric maxlength="1" show-errors [disabled]="isFhlbcUser == false" />
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 text-align-right-sm">
                <label class="control-label">{{cmsModel?.BorrowerLastName}}</label>
              </div>
              <div class="col-sm-6 form-group mb-3 margin-left--15px">
                <input type="text" id="borrowerLastName" name="borrowerLastName" alphanumeric
                       class="form-control"
                       [(ngModel)]="bestEffortsDeliveryData?.bestEffortsDeliveryData[0].borrowerLastName"
                       maxlength="{{  25 }}" #borrowerLastName="ngModel"
                       pattern="((?!\d{3}-?\d{2}-?\d{4}).)*$" show-errors required [disabled]="isFhlbcUser == false" />
                <div class="help-block row" *ngIf="(borrowerLastName.errors?.required && (borrowerLastName.touched || formSubmitted)) ||
                                            borrowerLastName.errors?.pattern">
                  <p class="col-sm-12" *ngIf="borrowerLastName.errors?.required">
                    This field is required
                  </p>
                  <p class="col-sm-12" *ngIf="borrowerLastName.errors?.pattern && (borrowerLastName.touched || formSubmitted)">
                    This
                    field cannot contain SSN number
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-5">
            <div class="row">
              <div class="col-sm-6 text-align-right-sm">
                <label class="control-label margin-left--5px padding-top-10px">{{cmsModel?.BorrowerSSN}}</label>
              </div>
              <div *ngIf="isFhlbcUser" class="col-sm-6 form-group mb-3 margin-left--15px padding-top-20px">
                <input type="text" id="borrowerSSN" name="borrowerSSN" class="form-control"
                       [(ngModel)]="bestEffortsDeliveryData?.bestEffortsDeliveryData[0].borrowerSSN"
                       #borrowerSSN="ngModel" mask="000-00-0000" show-errors required placeholder="___-__-____" />
                <div class="help-block row"
                     *ngIf="(borrowerSSN.invalid || borrowerSSN.errors?.required) && (borrowerSSN.touched || formSubmitted)">
                  <p class="col-sm-12" *ngIf="borrowerSSN.errors?.required">
                    {{ cmsModel.FieldRequired }}
                  </p>
                  <p class="col-sm-12" *ngIf="borrowerSSN.invalid && !borrowerSSN.errors?.required">
                    {{ cmsModel.InvalidSsnFormat }}
                  </p>
                </div>
              </div>
              <div *ngIf="!isFhlbcUser" class="col-sm-6 form-group mb-3 margin-left--15px padding-top-20px">
                <input type="text" id="borrowerSSN" name="borrowerSSN" class="form-control"
                       [(ngModel)]="bestEffortsDeliveryData?.bestEffortsDeliveryData[0].borrowerSSN" [disabled]="true" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- CoBorrowers Section (dynamic, no duplication) -->

      <div *ngFor="let coBorrower of coBorrowers; let idx = index">
        <ng-container *ngIf="coBorrower.coBorrowerExists">
          <div class="border-bottom-dashed">
            <div class="row">
              <div class="col-sm-3">
                <div class="padding-top-20px padding-bottom-30px fhlb-blue-font">
                  <strong>{{cmsModel.CoBorrowerText}} {{ idx + 1 }}</strong>
                </div>
              </div>
              <div *ngIf="isFhlbcUser == false" class="col-sm-9">
                <div class="padding-top-20px padding-bottom-30px text-align-right">
                  <p id="grayed-message">
                    To request edits to the grayed out fields in this section, please
                    call
                    the MPF Service Center at 877-345-2673.
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-7">
                <div class="row">
                  <div class="col-sm-6 text-align-right-sm">
                    <label class="control-label">
                      {{cmsModel.CoBorrowerText}}
                      #{{ idx + 1 }} {{cmsModel.FirstNameText}}:
                    </label>
                  </div>
                  <div class="col-sm-6 form-group mb-3 margin-left--15px">
                    <input type="text" id="coborrower-first-name-{{ idx + 1 }}" class="form-control"
                          name="coborrowerFirstName{{ idx + 1 }}" [(ngModel)]="coBorrowers[idx].firstName"
                          alphanumeric maxlength="{{  25 }}" #coborrowerfirstName="ngModel"
                          pattern="((?!\d{3}-?\d{2}-?\d{4}).)*$" show-errors required [disabled]="isFhlbcUser == false" />
                    <div id="coBorrower{{ idx + 1 }}FirstNameHelpBlock" class="help-block row" *ngIf="(coborrowerfirstName.errors?.required && (coborrowerfirstName.touched || formSubmitted)) ||
                                                coborrowerfirstName.errors?.pattern">
                      <p class="col-sm-12" *ngIf="coborrowerfirstName.errors?.required && (coborrowerfirstName.touched || formSubmitted)">
                        This
                        field is required
                      </p>
                      <p class="col-sm-12" *ngIf="coborrowerfirstName.errors?.pattern">
                        This
                        field cannot contain SSN number
                      </p>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6 text-align-right-sm">
                    <label class="control-label">
                      {{cmsModel.CoBorrowerText}}
                      #{{ idx + 1 }} {{cmsModel.MiddleInitialText}}:
                    </label>
                  </div>
                  <div class="col-sm-2 form-group mb-3 margin-left--15px">
                    <input type="text" id="coborrower-middle-initial-{{ idx + 1 }}" class="form-control"
                          name="coborrowerMiddleInitial{{ idx + 1 }}" [(ngModel)]="coBorrowers[idx].middleInitial"
                          alphanumeric maxlength="1" show-errors [disabled]="isFhlbcUser == false" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6 text-align-right-sm">
                    <label class="control-label">
                      {{cmsModel.CoBorrowerText}}
                      #{{ idx + 1 }} {{cmsModel.LastNameText}}:
                    </label>
                  </div>
                  <div class="col-sm-6 form-group mb-3 margin-left--15px">
                    <input type="text" id="coborrower-last-name-{{ idx + 1 }}" class="form-control"
                          name="coborrowerLastName{{ idx + 1 }}" [(ngModel)]="coBorrowers[idx].lastName"
                          alphanumeric maxlength="{{ 25 }}" pattern="((?!\d{3}-?\d{2}-?\d{4}).)*$"
                          #coborrowerlastname="ngModel" show-errors required [disabled]="isFhlbcUser == false" />
                    <div id="coborrower{{ idx + 1 }}LastNameHelpBlock" class="help-block row" *ngIf="(coborrowerlastname.errors?.required && (coborrowerlastname.touched || formSubmitted)) ||
                                                coborrowerlastname.errors?.pattern">
                      <p class="col-sm-12" *ngIf="coborrowerlastname.errors?.required && (coborrowerlastname.touched || formSubmitted)">
                        This
                        field is required
                      </p>
                      <p class="col-sm-12" *ngIf="coborrowerlastname.errors?.pattern">
                        This
                        field cannot contain SSN number
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-5">
                <div class="row">
                  <div class="col-sm-6 text-align-right-sm">
                    <label class="control-label">
                      {{cmsModel.CoBorrowerText}}
                      #{{ idx + 1 }} {{cmsModel.SSNText}}:
                    </label>
                  </div>
                  <div *ngIf="isFhlbcUser" class="col-sm-6 form-group mb-3 margin-left--15px padding-top-20px">
                    <input type="text" id="coborrower-ssn-{{ idx + 1 }}" class="form-control"
                          name="coborrowerSsn{{ idx + 1 }}" [(ngModel)]="coBorrowers[idx].ssn"
                          placeholder="___-__-____" #coborrowerssn="ngModel" mask="000-00-0000" show-errors required />
                    <div id="coborrower{{ idx + 1 }}SsnHelpBlock" class="help-block row"
                        *ngIf="(coborrowerssn.invalid || coborrowerssn.errors?.required) && (coborrowerssn.touched || formSubmitted)">
                      <p class="col-sm-12" *ngIf="coborrowerssn.errors?.required">
                        {{ cmsModel.FieldRequired }}
                      </p>
                      <p class="col-sm-12" *ngIf="coborrowerssn.invalid && !coborrowerssn.errors?.required">
                        {{ cmsModel.InvalidSsnFormat }}
                      </p>
                    </div>
                  </div>
                  <div *ngIf="!isFhlbcUser" class="col-sm-6 form-group mb-3 margin-left--15px padding-top-20px">
                    <input type="text" id="coborrower-ssn-{{ idx + 1 }}" class="form-control"
                          name="coborrowerSsn{{ idx + 1 }}" [(ngModel)]="coBorrowers[idx].ssn" [disabled]="true" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <!-- Property Section -->

      <div class="border-bottom-dashed">
        <div class="row">
          <div class="col-sm-3">
            <div class="padding-top-20px padding-bottom-30px fhlb-blue-font">
              <strong>{{cmsModel?.PropertyInformationText}}</strong>
            </div>
          </div>
          <div *ngIf="isFhlbcUser == false" class="col-sm-9">
            <div class="padding-top-20px padding-bottom-30px text-align-right">
              <p id="grayed-message">
                To request edits to the grayed out fields in this section, please
                call
                the MPF Service Center at 877-345-2673.
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="row col-sm-11 offset-sm-1 padding-left-0px">
            <div class="col-sm-3 text-align-right-sm padding-right-30px">
              <label class="control-label">{{cmsModel?.PropertyAddress}}</label>
            </div>
            <div class="col-sm-9 margin-left--22px form-group mb-3 padding-right-0px padding-left-0px"
              style="position: relative;">
              <input type="text" id="propertyAddress" name="propertyAddress" class="form-control"
                     alphanumeric
                     appAddressAutocomplete
                     (input)="onPropertyAddressInput($event, propertyAddressDirective)"
                     (addressSelected)="onAddressSelected($event)"
                     [(ngModel)]="bestEffortsDeliveryData?.bestEffortsDeliveryData[0].propertyAddress"
                     #propertyAddressDirective="appAddressAutocomplete"
                     #propertyAddress="ngModel" maxlength="{{100}}" pattern="((?!\d{3}-?\d{2}-?\d{4}).)*$"
                     show-errors required [disabled]="isFhlbcUser == false" />
              <ul *ngIf="propertyAddressDirective.suggestions && propertyAddressDirective.suggestions.length > 0" class="list-group" style="position: absolute; z-index: 1000; width: 100%; max-width: 600px;">
                <li *ngFor="let addr of propertyAddressDirective.suggestions; let i = index" class="list-group-item" style="cursor: pointer;"
                    (click)="propertyAddressDirective.selectSuggestion(addr)"
                    (mouseenter)="propertyAddressDirective.setSelectedIndex(i)"
                    (mouseleave)="propertyAddressDirective.clearSelectedIndex()"
                    [class.active]="i === propertyAddressDirective.selectedSuggestionIndex">
                    {{ addr.formattedAddress }}
                </li>
              </ul>
              <div class="help-block row" *ngIf="(propertyAddress.errors?.required && (propertyAddress.touched || formSubmitted)) ||
                                        propertyAddress.errors?.pattern">
                <p class="col-sm-12" *ngIf="propertyAddress.errors?.required">
                  This field is required
                </p>
                <p class="col-sm-12" *ngIf="propertyAddress.errors?.pattern">
                  This
                  field cannot contain SSN number
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-7">
            <div class="row">
              <div class="col-sm-6 text-align-right-sm">
                <label class="control-label">{{cmsModel?.City}}</label>
              </div>
              <div class="col-sm-6 form-group mb-3 margin-left--15px">
                <input type="text" id="city" name="city" class="form-control"
                       [(ngModel)]="bestEffortsDeliveryData?.bestEffortsDeliveryData[0].propertyCity"
                       #city="ngModel" alphanumeric maxlength="150" pattern="((?!\d{3}-?\d{2}-?\d{4}).)*$"
                       show-errors required [disabled]="isFhlbcUser == false" />
                <div class="help-block row" *ngIf="(city.errors?.required && (city.touched || formSubmitted)) ||
                                            city.errors?.pattern">
                  <p class="col-sm-12" *ngIf="city.errors?.required && (city.touched || formSubmitted)">
                    This
                    field is required
                  </p>
                  <p class="col-sm-12" *ngIf="city.errors?.pattern">
                    This
                    field cannot contain SSN number
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 text-align-right-sm">
                <label class="control-label">{{cmsModel?.State}}</label>
              </div>
              <div class="col-sm-6 form-group mb-3 margin-left--15px">
                <label class="select height-auto" *ngIf="isFhlbcUser; else showStateValue">
                  <select id="state" name="state" class="form-select"
                    [(ngModel)]="bestEffortsDeliveryData?.bestEffortsDeliveryData[0].propertyState" #state="ngModel"
                    show-errors required>
                    <ng-container *ngFor="let item of stateOptions">
                      <option class="feedback-form-input" [ngValue]="item.value">
                        {{item.value}}
                      </option>
                    </ng-container>
                  </select>
                  <div class="help-block row"
                     *ngIf="(state.invalid && formSubmitted) ||(state.errors?.required && (state.dirty || state.touched))">
                  <p class="col-sm-12">
                    This field is required
                  </p>
                </div>
                </label>

                <ng-template #showStateValue>
                  <input type="text" class="form-control" [value]="bestEffortsDeliveryData?.bestEffortsDeliveryData[0].propertyState" disabled />
                </ng-template>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-6 text-align-right-sm">
                <label class="control-label">{{cmsModel?.ZipCode}}</label>
              </div>
              <div class="col-sm-6 form-group mb-3 margin-left--15px">
                <input type="text" id="zipcode" name="zipcode" class="form-control"
                       [(ngModel)]="bestEffortsDeliveryData?.bestEffortsDeliveryData[0].propertyZipCode"
                       #zipcode="ngModel" pattern="\d{5}([\-]?\d{4})?$" placeholder="12345 or 12345-1234"
                       mask="99999-0000" clean="false" required show-errors [disabled]="isFhlbcUser == false" />
                <div class="help-block row"
                     *ngIf="(zipcode.invalid && formSubmitted) || (zipcode.errors?.required && (zipcode.dirty || zipcode.touched))">
                  <p class="col-sm-12">
                    This field is required
                  </p>
                </div>
                <div id="dcZipCodeHelpBlock" class="help-block" *ngIf="zipcode.errors?.pattern">
                  <p>Invalid Zip Code format.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-5">
            <div class="row">
              <div class="col-sm-6 text-align-right-sm">
                <label class="control-label">{{cmsModel?.PropertyType}}</label>
              </div>
              <div class="col-sm-6 form-group mb-3 margin-left--15px">
                <label class="select height-auto">
                  <select id="propertyType" name="propertyType" class="form-select"
                          [(ngModel)]="bestEffortsDeliveryData?.bestEffortsDeliveryData[0].propertyType"
                          #propertyType="ngModel" show-errors required>
                    <ng-container *ngFor="let item of propertyTypeOptions">
                      <option class="feedback-form-input" [ngValue]="item.value">
                        {{item.name}}
                      </option>
                    </ng-container>
                  </select>
                </label>
                <div class="help-block row"
                     *ngIf="(propertyType.invalid && formSubmitted) || (propertyType.errors?.required && (propertyType.dirty || propertyType.touched))">
                  <p class="col-sm-12">
                    This field is required
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Loan Information -->
      <div>
        <div class="padding-top-20px padding-bottom-30px fhlb-blue-font">
          <strong>{{cmsModel.LoanInformationText}}</strong>
        </div>
        <div class="row">
          <div class="col-sm-7">
            <div class="row">
              <div class="col-sm-6 text-align-right-sm">
                <label class="control-label">{{cmsModel.LoanPurpose}}</label>
              </div>
              <div class="col-sm-6 form-group mb-3 margin-left--15px">
                <label class="select height-auto">
                  <select id="loanPurpose" name="loanPurpose" class="form-select"
                                    [(ngModel)]="bestEffortsDeliveryData?.bestEffortsDeliveryData[0].loanPurpose" #loanPurpose="ngModel" show-errors required>
                                    <ng-container *ngFor="let item of loanPurposesOptions">
                                        <option class="feedback-form-input" [ngValue]="item.value">
                                            {{item.name}}
                                        </option>
                                    </ng-container>
                                </select>
                </label>
                <div class="help-block row"
                     *ngIf="(loanPurpose.invalid && formSubmitted) ||(loanPurpose.errors?.required && (loanPurpose.dirty || loanPurpose.touched))">
                  <p class="col-sm-12">
                    This field is required
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 text-align-right-sm">
                <label class="control-label">{{cmsModel.Occupancy}}</label>
              </div>
              <div class="col-sm-6 form-group mb-3 margin-left--15px">
                <label class="select height-auto">
                   <select id="occupancy" name="occupancy" class="form-select"
                                    [(ngModel)]="bestEffortsDeliveryData?.bestEffortsDeliveryData[0].occupancy" #occupancy="ngModel" show-errors required>
                                    <ng-container *ngFor="let item of occupancyOptions">
                                        <option class="feedback-form-input" [ngValue]="item.value">
                                            {{item.name}}
                                        </option>
                                    </ng-container>
                                </select>
                </label>
                <div class="help-block row"
                     *ngIf="(occupancy.invalid && formSubmitted)||(occupancy.errors?.required && (occupancy.dirty || occupancy.touched))">
                  <p class="col-sm-12">
                    This field is required
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 text-align-right-sm">
                <label class="control-label">{{cmsModel.SubordinateFinancingAmount}}</label>
              </div>
              <div class="col-sm-6 form-group mb-3 margin-left--15px">
                <input type="text" id="subordinateFinancingAmount" name="subordinateFinancingAmount"
                       class="form-control"
                       [(ngModel)]="bestEffortsDeliveryData?.bestEffortsDeliveryData[0].subordinateFinancingAmount"
                       #subordinateFinancingAmount="ngModel" allow-decimal-numbers toCurrency maxlength="15"
                       placeholder="$" (blur)="populateLTVAndTLTV()" show-errors required/>
                <div class="help-block row"
                     *ngIf="(subordinateFinancingAmount.invalid && formSubmitted) ||(subordinateFinancingAmount.errors?.required && (subordinateFinancingAmount.dirty || subordinateFinancingAmount.touched))">
                  <p class="col-sm-12">
                    This field is required
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 text-align-right-sm">
                <label class="control-label">{{cmsModel.AppraisedValue}}</label>
              </div>
              <div class="col-sm-6 form-group mb-3 margin-left--15px">
                <input type="text" id="appraisedValue" name="appraisedValue" class="form-control"
                       [(ngModel)]="bestEffortsDeliveryData?.bestEffortsDeliveryData[0].purchasePrice"
                       #appraisedValue="ngModel" toCurrency allow-decimal-numbers maxlength="15"
                       placeholder="$" (blur)="populateLTVAndTLTV()" show-errors required/>
                <div class="help-block row"
                     *ngIf="(appraisedValue.invalid && formSubmitted) || (appraisedValue.errors?.required && (appraisedValue.dirty || appraisedValue.touched))">
                  <p class="col-sm-12">
                    This field is required
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-5">
            <div class="row padding-bottom-10px">
              <div class="col-sm-6 control-label text-align-right">
                <label>{{cmsModel.LTVText}}</label>
              </div>
              <div class="col-sm-6 form-control-static">
                <span class="feedback-display-font padding-left-0px padding-top-7px"
                      *ngIf="bestEffortsDeliveryData?.bestEffortsDeliveryData[0].ltv != null">
                  {{bestEffortsDeliveryData?.bestEffortsDeliveryData[0].ltv || '00.00'}} %
                </span>
                <span class="feedback-display-font padding-left-0px padding-top-7px"
                      *ngIf="bestEffortsDeliveryData?.bestEffortsDeliveryData[0].ltv == null">
                  00.00
                  %
                </span>
              </div>
            </div>
            <div class="row padding-bottom-10px">
              <div class="col-sm-6 control-label text-align-right">
                <label>{{cmsModel.TLTVText}}</label>
              </div>
              <div class="col-sm-6 form-control-static">
                <span class="feedback-display-font padding-left-0px padding-top-7px"
                      *ngIf="bestEffortsDeliveryData?.bestEffortsDeliveryData[0].tltv != null">
                  {{bestEffortsDeliveryData?.bestEffortsDeliveryData[0].tltv || '00.00'}} %
                </span>
                <span class="feedback-display-font padding-left-0px padding-top-7px"
                      *ngIf="bestEffortsDeliveryData?.bestEffortsDeliveryData[0].tltv == null">
                  00.00
                  %
                </span>
              </div>
            </div>
            <div class="row padding-bottom-20px">
              <div class="col-sm-6 control-label text-align-right">
                <label>{{cmsModel.Comments}}</label>
              </div>
              <div #divcomments class="col-sm-5 form-group mb-3 display-block text-align-left"
                   id="divcomments">
                <textarea #comments id="comments" name="comment" rows="3"
                          class="form-control font-size-3"
                          [(ngModel)]="dcExistingModel.deliveryCommitment.comments"
                          maxlength="255"></textarea>
                <span class="font-size-1 text-lighter font-weight-100">{{cmsModel.CommentsDescription}}</span>
              </div>
            </div>
          </div>
          <div class="row col-sm-12 padding-bottom-15px" *ngIf="!isFhlbcUser">
            <div class="col-sm-2 offset-sm-4">
              <input type="submit" class="btn btn-default blackButton fw-bold" value="CANCEL" (click)="cancelDC()" />
            </div>
            <div class="col-sm-2">
              <input type="submit"
                     class="btn btn-success background-image-none feedback-form-button form-control padding-right-10px background-image-none fw-bold"
                     value="SUBMIT" id="dc-entry-validate-be" name="dc-entry-validate-be"
                     (click)="submitEditDc()" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<ng-template #popContent>
  <div class="margin-left--3px margin-right--3px">
    <div class="submit-batch-header text-center">
      {{cmsModel.NoteRateListTitle}}
    </div>
  </div>
  <div class="margin-left--3px margin-right--3px" id="tblNoteRatesList">
    <table class="table table-striped margin-bottom-10px">
      <thead class="font-color-dark-gray background-color-gray-2 text-center">
        <tr>
          <td class="font-bold">{{cmsModel.RatesText}}</td>
          <td class="font-bold">{{cmsModel.PremiumDiscountText}}</td>
        </tr>
      </thead>
      <tbody>
        <tr class="text-center" *ngFor="let noteRate of noteRates">
          <td>
            <a class="font-color-dark-orange text-decoration-underline"
               (click)="selectNoteRate(noteRate.rate)">{{(noteRate.rate*100).toFixed(3)}}%</a>
          </td>
          <td>{{(noteRate.agentFee*100).toFixed(8)}}%</td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>